import axiosInstance from "../../../../config/Helpers";

const updateStore = async (id, data) => {
    const res = await axiosInstance.patch(`affiliate-program/rakuten/${id}`, {
        ...data,
    });
    return res;
};
export default updateStore;
